document.addEventListener('DOMContentLoaded', () => {
  for (const root of document.querySelectorAll('[data-rfm-faq]')) {
    const items = [...root.querySelectorAll('details')];

    root.addEventListener('toggle', ({ target }) => {
      if (!target.open) return;
      for (const item of items) {
        if (item !== target) item.open = false;
      }
    }, true);
  }
});
